import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { Image } from "../../Image";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(Image, {
        width: 20,
        height: 22,
        src: "https://ftmscan.com/images/coingecko.svg",
        style: {
            height: 22,
            width: 22
        }
    });
};
export default Icon;
